import styled from '@emotion/styled';
import { getCSSVariable, getTypographyCSSVariable } from '@opendoor/bricks-next';

/* These styles are added as they have to be applied to the dynamic contents from contentful child nodes, 
so have to inject them as inline css
*/
const ArticleContainer = styled.div`
  width: 100%;
  max-width: 1440px;
  padding: 64px 24px;
  margin: auto;
  > p,
  > ul,
  > ol,
  > hr,
  > table,
  > h1,
  > h2,
  > h3,
  > h4,
  > blockquote {
    grid-column: 5 / -2;
    margin-bottom: 0;
  }
  > h1,
  > h2,
  > h3,
  > h4 {
    font-weight: 400;
  }
  > h1 b,
  > h1 strong,
  > h2 b,
  > h2 strong,
  > h3 b,
  > h3 strong,
  > h4 b,
  > h4 strong {
    font-weight: inherit;
  }
  > p b,
  > p strong {
    font-weight: 500;
  }
  > div {
    grid-column: 1 / -1;
    margin-bottom: 0;
  }
  hr {
    background-color: ${getCSSVariable('$backgroundStateHoverSecondary')};
    border: none;
    grid-column: 2 / -2;
    height: 1px;
    margin-inline: auto;
    width: 100%;
  }

  > * + * {
    margin-top: ${getCSSVariable('$12x')} !important;
  }

  > h1 + *,
  > h2 + *,
  > h3 + *,
  > h4 + *,
  > * + h1,
  > * + h2,
  > * + h3,
  > * + h4,
  > * + .embedded-entry-wrapper,
  > .embedded-entry-wrapper + *,
  > * + hr,
  > hr + * {
    margin-top: ${getCSSVariable('$24x')} !important;
  }

  @media (min-width: 768px) {
    display: grid;
  }
`;

const ArticleHeaderContainer = styled.div`
  > * + * {
    margin-top: 24px;
  }
  > p:first-child {
    font-size: ${getTypographyCSSVariable('$subheaderSmall', 'size')};
    letter-spacing: ${getTypographyCSSVariable('$subheaderSmall', 'letterSpacing')};
    line-height: ${getTypographyCSSVariable('$subheaderSmall', 'lineHeight')};
  }
  > p:first-child + * {
    margin-top: ${getCSSVariable('$32x')};
  }
  ul {
    list-style: none;
    margin-left: 0;
    padding-left: 0;
  }
  a,
  a:visited {
    color: ${getCSSVariable('$contentPrimary')};
  }
  a:hover {
    color: ${getCSSVariable('$backgroundAccentBrand')};
  }
`;

export { ArticleContainer, ArticleHeaderContainer };
